<div class="container h-100">
	<div
		class="row h-100 justify-content-center align-items-center scroll-mobile"
	>
		<div class="col-12 col-md-6">
			<img
				class="img-fluid"
				src="assets/images/ilustracao-asaas-erro.svg"
				alt="base logo"
			/>
		</div>
		<div class="col-12 col-md-6">
			<div>
				<h1 class="text-primary fw-bold">
					Não foi possível entrar em sua conta
				</h1>
				<h3 class="fw-bold my-4">Aconteceu um erro inesperado</h3>
				<p>
					Estamos trabalhando para resolver esse problema. Tente
					novamente em alguns instantes. Se precisar de ajuda
					imediata, acesse a
					<a
						class="text-decoration-underline"
						href="https://ajuda.asaas.com/pt-BR/"
						>Central de Ajuda</a
					>
					ou entre em contato por um de nossos canais de atendimento:
				</p>
			</div>
			<div>
				<div class="mb-2">
					<img
						class="icon"
						src="assets/icons/assas-login-error/email.svg"
					/>
					<a
						class="text-decoration-underline"
						href="mailto: contato@asaas.com.br"
						>contato&#64;asaas.com.br
					</a>
				</div>
				<div class="mb-2">
					<img
						class="icon"
						src="assets/icons/assas-login-error/phone.svg"
					/>
					<span>0800 009 0037</span>
				</div>
				<div class="mb-3">
					<img
						class="icon"
						src="assets/icons/assas-login-error/whatsapp.svg"
					/>
					<span class="text-primary text-decoration-underline"
						>(47) 99138-5151
					</span>
				</div>
				<a href="https://www.asaas.com/" class="btn btn-primary my-2">
					Voltar para o Asaas
				</a>
			</div>
		</div>
	</div>
</div>
